const API_URL = process.env.REACT_APP_API_URL || '';

function resolveApiBaseUrl() {
    if (API_URL) return API_URL;
    return '';
}

const API_BASE_URL = resolveApiBaseUrl();

function shouldAttachToken(url) {
    if (!url) return false;
    if (typeof url !== 'string') return true;
    if (url.startsWith('/api/')) return true;
    if (API_BASE_URL && url.startsWith(API_BASE_URL)) return true;
    return false;
}

function mergeHeaders(existingHeaders) {
    const headers = new Headers(existingHeaders || {});
    return headers;
}

export function installAuthFetch() {
    if (typeof window === 'undefined') return;
    if (window.__safetensorAuthFetchInstalled) return;
    window.__safetensorAuthFetchInstalled = true;

    const originalFetch = window.fetch?.bind(window);
    if (!originalFetch) return;

    window.fetch = async (input, init = {}) => {
        const requestUrl = typeof input === 'string' ? input : input?.url || '';
        const isRelativeApiRequest = typeof input === 'string' && requestUrl.startsWith('/api/');
        const normalizedInput =
            isRelativeApiRequest && API_BASE_URL
                ? `${API_BASE_URL}${requestUrl}`
                : input;

        if (!shouldAttachToken(requestUrl)) {
            return originalFetch(normalizedInput, init);
        }

        const headers = mergeHeaders(init.headers || (input instanceof Request ? input.headers : undefined));
        const credentials = init.credentials || 'include';
        if (input instanceof Request) {
            return originalFetch(new Request(input, { ...init, headers, credentials }));
        }

        return originalFetch(normalizedInput, { ...init, headers, credentials });
    };
}
